<div class="modal-layout" *ngIf="vm">
  <!-- ====== LEFT: SETTINGS PANEL ====== -->
  <div class="modal-settings">
    <h1>Modal Creator</h1>

    <!-- Basic -->
    <h2>Basic</h2>
    <div class="form-row">
      <label>Modal Name:</label>
      <input type="text" [(ngModel)]="vm.name" />
    </div>

    <!-- Behavior -->
    <h2>Behavior</h2>
    <div class="form-row">
      <label>Trigger Type:</label>
      <select [(ngModel)]="vm.triggerType">
        <option *ngFor="let type of vm.triggerTypes" [value]="type">{{ type }}</option>
      </select>
    </div>

    <div class="form-row">
      <label>Overlay Close:</label>
      <input type="checkbox" [(ngModel)]="vm.overlayClose" />
    </div>

    <!-- Design -->
    <h2>Design</h2>
    <div class="form-row">
      <label>Template:</label>
      <select [(ngModel)]="vm.selectedTemplate" (change)="bindEditor()">
        <option *ngFor="let t of vm.designTemplates" [ngValue]="t">
          {{ t.templateName }}
        </option>
      </select>
    </div>

    <!-- Template details -->
    <div class="modal-design" *ngIf="vm.selectedTemplate">
      <h3>Overlay</h3>

      <div class="form-row">
        <label>Fade In Speed:</label>
        <input
          type="range"
          min="0"
          max="1000"
          [(ngModel)]="vm.selectedTemplate.overlayFadeInString"
        />
      </div>

      <div class="form-row">
        <label>Fade Out Speed:</label>
        <input
          type="range"
          min="0"
          max="1000"
          [(ngModel)]="vm.selectedTemplate.overlayFadeOutString"
        />
      </div>

      <div class="form-row">
        <label>Color:</label>
        <input type="text" [(ngModel)]="vm.selectedTemplate.overlayColor" />
      </div>

      <div class="form-row">
        <label>Opacity:</label>
        <input
          type="range"
          min="0"
          max="100"
          [(ngModel)]="vm.selectedTemplate.overlayOpacity"
        />
      </div>

      <h3>Modal</h3>

      <div class="form-row">
        <label>Height:</label>
        <input
          type="range"
          min="5"
          max="100"
          [(ngModel)]="vm.selectedTemplate.modalHeight"
        />
      </div>

      <div class="form-row">
        <label>Width:</label>
        <input
          type="range"
          min="5"
          max="100"
          [(ngModel)]="vm.selectedTemplate.modalWidth"
        />
      </div>

      <div class="form-row">
        <label>Color:</label>
        <input type="text" [(ngModel)]="vm.selectedTemplate.modalColor" />
      </div>

      <div class="form-row">
        <label>Opacity:</label>
        <input
          type="range"
          min="0"
          max="100"
          [(ngModel)]="vm.selectedTemplate.modalOpacity"
        />
      </div>

      <div class="textarea-row">
        <label>Content:</label>
        <textarea [(ngModel)]="vm.selectedTemplate.innerHTML"></textarea>
      </div>
    </div>

    <button (click)="testModal()">Test Modal</button>
  </div>

  <!-- ====== RIGHT: LIVE PREVIEW ====== -->
  <div class="modal-preview" *ngIf="vm.selectedTemplate">
    <div
      class="overlay"
      [ngStyle]="{
        background: vm.selectedTemplate.overlayColor,
        opacity: vm.selectedTemplate.overlayOpacity / 100
      }"
    ></div>

    <div
      class="modal"
      [ngStyle]="{
        background: vm.selectedTemplate.modalColor,
        width: vm.selectedTemplate.modalWidth + '%',
        height: vm.selectedTemplate.modalHeight + '%',
        opacity: vm.selectedTemplate.modalOpacity / 100
      }"
    ></div>

    <div
      class="content"
      [innerHTML]="safeHTML(vm.selectedTemplate.innerHTML)"
      [ngStyle]="{
        width: vm.selectedTemplate.modalWidth + '%',
        height: vm.selectedTemplate.modalHeight + '%'
      }"
    ></div>
  </div>
</div>
